import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import '../style.scss';
import useToast from "../../../../../../hook/useToast";
import { IDuplicate } from "../../../../../../api/groupCustomer/groupCustomerApi";

import { Input, Tree } from 'antd';
import type { TreeDataNode } from 'antd';
import { useEffect, useMemo, useState } from "react";
import { NodeEvent, TreeNode } from "../../SideBar";
import useDebounce from "../../../../../../hook/useDebounce";
import { getListGroup } from "../../../../../../api/groupCustomerV2/groupCustomerV2Api";
import { convertGroupsToTreeNode } from "../../../indexV2";
import useLoading from "../../../../../../hook/useLoading";
import { useSelector } from "react-redux";
import { selectorCategoryCarIds } from "../../../../../../store/slices/categoryCarSlice";

const { Search } = Input;

const x = 3;
const y = 2;
const z = 1;
const defaultData: TreeDataNode[] = [];

const generateData = (_level: number, _preKey?: React.Key, _tns?: TreeDataNode[]) => {
  const preKey = _preKey || '0';
  const tns = _tns || defaultData;

  const children: React.Key[] = [];
  for (let i = 0; i < x; i++) {
    const key = `${preKey}-${i}`;
    tns.push({ title: key, key });
    if (i < y) {
      children.push(key);
    }
  }
  if (_level < 0) {
    return tns;
  }
  const level = _level - 1;
  children.forEach((key, index) => {
    tns[index].children = [];
    return generateData(level, key, tns[index].children);
  });
};
generateData(z);

const dataList: { key: React.Key; title: string }[] = [];
const generateList = (data: TreeDataNode[]) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i];
    const { key } = node;
    dataList.push({ key, title: key as string });
    if (node.children) {
      generateList(node.children);
    }
  }
};
generateList(defaultData);

const getParentKey = (key: React.Key, tree: TreeDataNode[]): React.Key => {
  let parentKey: React.Key;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey!;
};

export interface IDataDefaulFilterList {
  search?: string
}
export const dataDefaulFilterList: IDataDefaulFilterList = {
  search: undefined,
};
interface ModalProps {
  isOpen: boolean
  infoDuplicate?: IDuplicate
  closeModal: () => void
}

const ModalCreateGroupCustomer_V2: React.FC<ModalProps> = ({
  isOpen, infoDuplicate,
  closeModal,
}) => {

  const pushToast = useToast();
  const navigate = useNavigate()
  const pushLoading = useLoading()
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)


  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [listGroup, setListGroup] = useState<TreeNode[]>([])
  const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)


  const gListGroup = useDebounce(async () => {
    pushLoading(true)
    const { search } = dataFilterList
    const result = await getListGroup(
      permittedCategoryCarIds,
      undefined, undefined, undefined, undefined, search
    )
    if (result.status) {
      setListGroup(convertGroupsToTreeNode(result.data))
    } else {
      pushToast(result.message, "warning")
      setListGroup([])
    }
    pushLoading(false)
  }, 1000)

  const onExpand = (newExpandedKeys: React.Key[]) => {
    setExpandedKeys(newExpandedKeys);
    setAutoExpandParent(false);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setDataFilterList({ ...dataFilterList, search: value })
  };

  const handleSelect = (selectedKeys: React.Key[], info: any) => {
    const clickedItem = info.node; // node Tree vừa click
    const itemNode: TreeNode = {
      key: clickedItem?.key,
      level: clickedItem?.level,
      parentId: clickedItem?.parentId,
      title: clickedItem?.title,
    }
    const itemGroup = [infoDuplicate?.group1.id, infoDuplicate?.group2.id]

    navigate("/customer/group", {
      state: {
        nodeEvent: {
          action: "combine",
          item: itemNode
        } as NodeEvent,
        itemCombineGroup: itemGroup
      },
    });
  };

  useEffect(() => {
    if (isOpen) {
      gListGroup()
    } else {
      setDataFilterList(dataDefaulFilterList)
    }
  }, [isOpen, dataFilterList])
  return (
    <Modal
      title={<div className="custom-page-css bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0 rounded overflow-hidden">
        <span className="text-base text-344054 fw-500 font-medium">Chọn nhóm khách hàng</span>
        <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
      </div>}
      open={isOpen}
      onCancel={closeModal}
      centered
      className="w-modal modal-content-update-group ant-modal-size"
      closeIcon={false}
      footer={false}
    >
      <div className="px-4 py-2">
        <Input
          style={{ marginBottom: 8 }}
          placeholder="Tìm nhóm"
          value={dataFilterList.search}
          onChange={onChange}
        />
        <Tree
          onExpand={onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
          treeData={listGroup}
          onSelect={handleSelect}
        />
      </div>
    </Modal>
  )
}
export default ModalCreateGroupCustomer_V2
